export const initialSubscriptions = {
  name: '',
  description: '',
  moderate: true,
  roles: [],
  promotion: {
    duration: '',
    payment: {
      amount: null,
      currency: '',
      recurring: null,
    },
  },
  channelCID: {
    orgId: '',
    streamId: '',
    channelId: '',
  },
  payment: {
    amount: null,
    currency: '',
    recurring: null,
  },
  stripeData: {
    priceId: '',
  },
  id: '',
};
